/**
 * Training alerts contextual nudge dialog UI.
 */
import React from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import {
  TRAINING_ALERTS_LANDING_H1,
  TRAINING_ALERTS_LANDING_INTRO,
  TRAINING_ALERTS_LANDING_PRIMARY_CTA,
} from '../../../shared/seo/trainingAlertsLandingCopy';

export type TrainingAlertsNudgeDialogProps = {
  open: boolean;
  onAccept: () => void;
  onSoftDismiss: () => void;
  onHardOptOut: () => void;
  onClose: () => void;
};

const TrainingAlertsNudgeDialog: React.FC<TrainingAlertsNudgeDialogProps> = ({
  open,
  onAccept,
  onSoftDismiss,
  onHardOptOut,
  onClose,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="training-alerts-nudge-title"
      data-testid="training-alerts-nudge-dialog"
    >
      <DialogTitle id="training-alerts-nudge-title" sx={{ pr: 6 }}>
        {TRAINING_ALERTS_LANDING_H1}
        <IconButton
          aria-label="Close"
          onClick={onClose}
          size="small"
          sx={{ position: 'absolute', right: 8, top: 8 }}
          data-testid="training-alerts-nudge-close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
          {TRAINING_ALERTS_LANDING_INTRO}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          flexDirection: 'column',
          alignItems: 'stretch',
          gap: 1,
          px: 3,
          pb: 2,
        }}
      >
        <Button
          variant="contained"
          onClick={onAccept}
          data-testid="training-alerts-nudge-accept"
          sx={{ fontWeight: 600 }}
        >
          {TRAINING_ALERTS_LANDING_PRIMARY_CTA}
        </Button>
        <Button
          variant="outlined"
          onClick={onSoftDismiss}
          data-testid="training-alerts-nudge-soft-dismiss"
        >
          Maybe later
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <Button
            variant="text"
            size="small"
            color="inherit"
            onClick={onHardOptOut}
            data-testid="training-alerts-nudge-hard-opt-out"
          >
            Don&apos;t ask again
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default TrainingAlertsNudgeDialog;
